import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import disable from "../assets/images/limit-buy.svg";
import { Button } from "@mantine/core";

const DisableAccount = () => {
  return (
    <>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />
        <div className="max-w-7xl mx-auto p-6 flex flex-col items-center justify-center my-6">
          <div className="shadow-md rounded-lg lg:px-16 px-3">
            <h1 className="text-2xl font-bold mb-4">Disable Account</h1>
            <img
              src={disable}
              alt="Disable Account"
              className="w-full max-w-md mx-auto mb-6"
            />
            <p>
              Please be aware of the following impacts on your account once it
              is disabled:
            </p>
            <div class=" w-full md:bg-[--color-Vessel] bg-transparent rounded-[12px] border border-solid border-[--color-Line] md:border-none md:rounded-xl p-4">
              <div class="flex items-start typography-body2 md:typography-body3">
                <svg
                  class="bn-svg mt-[4px] mr-[4px] text-[16px] w-[16px] h-[16px]"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.176 7.934a.25.25 0 00-.353 0l-3.89 3.89a.25.25 0 000 .353l3.89 3.889a.25.25 0 00.353 0l3.89-3.89a.25.25 0 000-.353l-3.89-3.889z"
                    fill="currentColor"
                  ></path>
                </svg>
                All pending withdrawals will be canceled.
              </div>
              <div class="flex items-start typography-body2 md:typography-body3">
                <svg
                  class="bn-svg mt-[4px] mr-[4px] text-[16px] w-[16px] h-[16px]"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.176 7.934a.25.25 0 00-.353 0l-3.89 3.89a.25.25 0 000 .353l3.89 3.889a.25.25 0 00.353 0l3.89-3.89a.25.25 0 000-.353l-3.89-3.889z"
                    fill="currentColor"
                  ></path>
                </svg>
                All trading functions for your account will be disabled.
              </div>
              <div class="flex items-start typography-body2 md:typography-body3">
                <svg
                  class="bn-svg mt-[4px] mr-[4px] text-[16px] w-[16px] h-[16px]"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.176 7.934a.25.25 0 00-.353 0l-3.89 3.89a.25.25 0 000 .353l3.89 3.889a.25.25 0 00.353 0l3.89-3.89a.25.25 0 000-.353l-3.89-3.889z"
                    fill="currentColor"
                  ></path>
                </svg>
                All API keys for your account will be deleted.
              </div>
              <div class="flex items-start typography-body2 md:typography-body3">
                <svg
                  class="bn-svg mt-[4px] mr-[4px] text-[16px] w-[16px] h-[16px]"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.176 7.934a.25.25 0 00-.353 0l-3.89 3.89a.25.25 0 000 .353l3.89 3.889a.25.25 0 00.353 0l3.89-3.89a.25.25 0 000-.353l-3.89-3.889z"
                    fill="currentColor"
                  ></path>
                </svg>
                All devices for your account will be deleted.
              </div>
              <div class="flex items-start typography-body2 md:typography-body3">
                <svg
                  class="bn-svg mt-[4px] mr-[4px] text-[16px] w-[16px] h-[16px]"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.176 7.934a.25.25 0 00-.353 0l-3.89 3.89a.25.25 0 000 .353l3.89 3.889a.25.25 0 00.353 0l3.89-3.89a.25.25 0 000-.353l-3.89-3.889z"
                    fill="currentColor"
                  ></path>
                </svg>
                Your identity verification information will not be deleted.
              </div>
            </div>
            <div className="flex justify-center items-center my-8"><Button>Disable Account</Button></div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default DisableAccount;
